//GLOBAL - components from npm
import React, { useState } from "react";
import { useSelector } from "react-redux";

//COMPONENTS
import Modal from "..";
import { Button, Typography } from "../../../general";
import Loading from "../../Loading";
import { Toast } from "../../../../utils/toast";

//SERVICES - api, conectors...
import * as APIUser from "../../../../services/api/User";

//GLOBAL STATE - redux, env...

// UTILS

//ASSETS - icons, images...
import { ReactComponent as KeyIcon } from "../../../../assets/icons/key.svg";

//STYLES

import "./redefine-password.scss";

export default function RedefinePassword({ isOpen, onClose, userId }) {
    //REDUX - Selectors
    const token = useSelector((state) => state.auth.token);

    //GENERAL

    //STATES
    const [pageStatus, setPageStatus] = useState("awaiting");

    //FUNCTIONS
    function onCloseCustom() {
        onClose();
    };

    async function handleRedefinePassword() {
        setPageStatus("redefine-password");

        const data = {
            id_usuario: userId
        };

        try {
            const response = await APIUser.redefinePassword(token, data)

            if (response.status === 200) {
                onCloseCustom();
                Toast(
                    "Senha redefinida!",
                    "Senha redefinida com sucesso.",
                    "success"
                );
            } else {
                const responseData = await response.json();
                throw new Error(responseData.message || "Falha ao redefinir a senha do usuário.");
            }
        } catch (error) {
            console.error("Erro ao redefinir a senha do usuário:", error);

            Toast(
                "Não foi possível redefinir a senha do usuário!",
                "Verifique sua conexão e tente novamente mais tarde.",
                "error"
            );
        } finally {
            setPageStatus("awaiting");
        }
    }

    //USE MEMOS

    //USE EFFECTS 
    return (
        <Modal.Main
            className="modal-redefine-password"
            title="Redefinir senha"
            width="443px"
            height="280px"
            titleColor={"black"}
            isOpen={isOpen}
            onClose={onClose}
            shouldCloseOnOverlayClick={false}
            headerContainerStyle={{ alignItems: "center" }}
            icon={
                <div className="modal-redefine-password__icon">
                    <KeyIcon />
                </div>
            }
            footer={
                <div className="container-footer">
                    <Button
                        onClick={() => onCloseCustom()}
                        className="modal-redefine-password__btn-cancel"
                        disabled={pageStatus === "redefine-password"}
                    >
                        <Typography.H4 weight={"bold"} color="blue-selected-4">
                            Cancelar
                        </Typography.H4>
                    </Button>

                    <Button
                        className="modal-redefine-password__btn-confirm"
                        disabled={pageStatus === "redefine-password"}
                        onClick={handleRedefinePassword}
                    >
                        {pageStatus !== "redefine-password" ? (
                            <Typography.H4 weight={"bold"} color="white">Redefinir</Typography.H4>
                        ) : (
                            <Loading.Dots />
                        )}
                    </Button>
                </div>
            }
        >
            <Typography.H4
                color="gray-180"
                weight="400"
                className="information-text"
            >
                Você tem certeza que deseja redefinir a senha? Ao redefinir, a senha do usuário será a padrão.
            </Typography.H4>
        </Modal.Main>
    )
}
